'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = require('../../lib/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Radio__hiddenInput___3fGAk',
  'labelContainer': 'Radio__labelContainer___hF4Uy',
  'labelContainerDisabled': 'Radio__labelContainerDisabled___1mvHZ',
  'radioButton': 'Radio__radioButton___n0CA5',
  'innerButton': 'Radio__innerButton___Vm1Wp',
  'innerButtonChecked': 'Radio__innerButtonChecked___PtR7P',
  'label': 'Radio__label___2_a4i',
  'children': 'Radio__children___3tJgD',
  'childrenDisabled': 'Radio__childrenDisabled___VMApn',
  'buttonChecked': 'Radio__buttonChecked___1uG0_',
  'innerButtonDisabled': 'Radio__innerButtonDisabled___21pZ4',
  'buttonDisabled': 'Radio__buttonDisabled___1DSTu'
};

var DefaultRadio = (0, _mergeThemeHoc2.default)(style)(_Radio2.default);
DefaultRadio.displayName = 'DefaultRadio';
exports.default = DefaultRadio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Radio/index.js
// module id = ./node_modules/dibs-elements/dist/Radio/index.js
// module chunks = 4